import React from "react";
import SectionCommonTable from "../../components/SectionCommonTable";
import LevelBonusTable from "./Table/levelBonusTable";

const LevelBonusPage = () => {
  return (
    <SectionCommonTable
      wrapperClassName="levelbonus_table"
      cardStyle={{ backgroundColor: "#fff" }}
      sectionTableTitle="Level Bonus"
      table={<LevelBonusTable />}
    />
  );
};

export default LevelBonusPage;
